/** Tiny inline-SVG icon, matching the v3 wireframe's <Icon d={…} size /> helper. */
import type { ReactNode } from "react";

export function Icon({
  d,
  size = 16,
  className,
}: {
  d: ReactNode;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {d}
    </svg>
  );
}

/** Accent used throughout the v3 wireframe (Tessa purple). */
export const ACCENT = "#7c5cff";
